const KEY_ADMIN_BASE_URL = "VITE_ADMIN_BASE_URL";
const KEY_AUTH_SERVER_BASE_URL = "VITE_AUTH_SERVER_BASE_URL";
const KEY_GUAC_BASE_URL = "VITE_GUAC_BASE_URL";
const KEY_INTERNAL_RECRUITER_BASE_URL = "VITE_INTERNAL_RECRUITER_BASE_URL";
const KEY_MIXPANEL_TOKEN = "VITE_MIXPANEL_TOKEN";
const KEY_NOVA_BASE_URL = "VITE_NOVA_BASE_URL";
const KEY_SENTRY_DSN = "VITE_SENTRY_DSN";
const KEY_TALENT_BASE_URL = "VITE_TALENT_BASE_URL";
const KEY_WORKABLE_NEW_JOB_FORM_URL = "VITE_WORKABLE_NEW_JOB_FORM_URL";

const getOptionalEnvironmentVariable = (key: string): string | undefined => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return import.meta.env[key];
};

const getRequiredEnvironmentVariable = (key: string): string => {
  const val = getOptionalEnvironmentVariable(key);
  if (!val) {
    throw new Error(`Environment variable ${key} must be defined!`);
  }

  return val;
};

export const env = {
  getAdminBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_ADMIN_BASE_URL);
  },
  getAuthServerBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_AUTH_SERVER_BASE_URL);
  },
  getGuacBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_GUAC_BASE_URL);
  },
  getInternalRecruiterBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_INTERNAL_RECRUITER_BASE_URL);
  },
  getMixpanelToken: () => {
    return getRequiredEnvironmentVariable(KEY_MIXPANEL_TOKEN);
  },
  getNovaBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_NOVA_BASE_URL);
  },
  getSentryDsn: () => {
    return getRequiredEnvironmentVariable(KEY_SENTRY_DSN);
  },
  getTalentBaseUrl: () => {
    return getRequiredEnvironmentVariable(KEY_TALENT_BASE_URL);
  },
  getWorkableNewJobFormUrl: () => {
    return getRequiredEnvironmentVariable(KEY_WORKABLE_NEW_JOB_FORM_URL);
  },
  /**
   * Returns `true` if the environment is production. This
   * is a special built-in constant that is set by Vite.
   *
   * https://vite.dev/guide/env-and-mode#built-in-constants
   */
  getIsProduction: () => {
    return import.meta.env.PROD;
  },
};
